import React from 'react';

import { Route } from 'react-router-dom';
import PrivateContent from 'containers/private-content';
import HomePage from 'components/pages/home-page';
import {
  getFixedQueryParamObject,
  parseQueryString,
} from '../utils/query-string-operations';
import LetterFormationContainer from 'containers/letter-formation-container';
import LNFContainer from 'containers/lnf-container';

function LetterNumberFormationsRoute({
  useSSO,
  onAuth,
  onForbidden,
  onAuthFailure,
}) {
  return (
    <Route
      path='/'
      component={({ history, location }) => {
        const queryObject = location.search
          ? getFixedQueryParamObject(parseQueryString(location.search))
          : null;
        const isLite = queryObject ? queryObject.lite : false;

        return (
          <LetterFormationContainer history={history} isLite={isLite}>
            <Route path='/' exact={true} component={HomePage} />
            <Route
              path='/draw'
              component={({ match }) => {
                return (
                  <PrivateContent
                    bypassed={!useSSO}
                    onAuth={onAuth(match.params)}
                    onForbidden={onForbidden(history)}
                    onAuthFailure={onAuthFailure}
                  >
                    <LNFContainer
                      isLite={isLite}
                      {...match.params}
                      queryObject={queryObject}
                    />
                  </PrivateContent>
                );
              }}
            />
          </LetterFormationContainer>
        );
      }}
    />
  );
}

export default LetterNumberFormationsRoute;
